import { useAppCookies } from ".";
import { useAppSelector } from "../../redux";
import { AKnownRole } from "../../types/user";

/**
 * This hook will check role ID in redux store first, if failed it will check Cookies.
 */
const useRoleUser = () => {
  const [{ roleId }] = useAppCookies(["roleId"]);
  const typefromstore = useAppSelector(
    ({ userstore }) => userstore.userData?.data?.role_id
  );
  const role: AKnownRole = typefromstore ?? roleId;

  return role;
};

export default useRoleUser;
